import { Layout, DefineRoute as DefineRouteComponent } from "components"
export const DefineRoute = () => {
 return (
  <Layout>
   <DefineRouteComponent />
  </Layout>
 )
}
